import { render, staticRenderFns } from "./FormsForm.vue?vue&type=template&id=0400569c&scoped=true"
import script from "./FormsForm.vue?vue&type=script&lang=js"
export * from "./FormsForm.vue?vue&type=script&lang=js"
import style0 from "./FormsForm.vue?vue&type=style&index=0&id=0400569c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0400569c",
  null
  
)

export default component.exports